<template>
  <Dialog
    width="608px"
    titleAlign="center"
    :title="null"
    :subTitle="null"
    :hideCloseBtn="createRenderType == 'pc' ? false : true"
    :showBottomCloseBtn="createRenderType == 'pc' ? false : true"
    :visible="visible"
    @close="closeDialog"
    background="linear-gradient(130deg, #5325A2 0%, #7D6FD6 47%, #501269 100%)"
    :backgroundImage="false"
    :customClass="`${createRenderType}-vocal-dialog vocal-dialog`"
  >
    <div>
      <div class="name">{{ $$t("credit.custom_vocal") }}</div>
      <div class="tip">{{ $$t("credit.transform_track") }}</div>
      <VocalGroup type="voice"></VocalGroup>
      <div class="try" @click="handleTry">
        <span>{{ $$t("credit.try_it_now") }}</span>
      </div>
    </div>
    <div class="flag flex-center">{{ $$t("credit.new_feature") }}</div>
  </Dialog>
</template>

<script setup>
import { defineProps, defineEmits, getCurrentInstance, watch } from "vue";
import { useRouter } from "vue-router";
import { $$language, $$t, $$tValue } from "@/i18n/i18n.js"

import { storeToRefs } from "pinia";
import VocalGroup from "../../create/subscribe-dialog/vocal.vue";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import { reportGeneral } from "@/api/api/apiCredit.js";
import useDialogStore from "@/store/dialogStore.js";

const dialogStore = useDialogStore();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  isFirst: {
    type: Boolean,
    default: true,
  },
});
const emits = defineEmits(["updata:visible", "updata: isFirst"]);
const router = useRouter();

const reportVocal = () => {
  reportGeneral({
    type: "home_vocal",
  }).then((res) => {});
};

watch(
  () => props.visible,
  (val) => {
    if (val) {
      globalProperties.logViewEvent("splashads_vocal");
      // reportVocal();
    }
  },
  {
    immediate: true,
  }
);

const closeDialog = () => {
  emits("update:visible", false);
  dialogStore.getPopupShow()
  globalProperties.logClickEvent("splashads_vocal_close");
};

const handleTry = () => {
  emits("update:visible", false);
  globalProperties.logClickEvent("splashads_vocal_tryitnow");
  createLayoutStore.setCurHighlightReferType({
    type: "vocal",
  });
  createLayoutStore.toggleCreateEditOpenState(true);
  createLayoutStore.setCreateEditMode("hard");
  router.push({
    name: "create",
  });
};
</script>

<style lang="scss" scoped>
.vocal-dialog {
  position: relative;
  .flag {
    position: absolute;
    width: 166px;
    height: 36px;
    background: url("@/assets/img/feature_bg.png");
    background-size: 100% 100%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }
  .name {
    color: #fff;
    font-size: 48px;
    font-weight: bold;
    text-align: center;
    margin-top: 16px;
  }
  .tip {
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    margin: 4px 0 24px;
    text-align: center;
  }
  .vocal-group {
    color: #fff;
  }
  .try {
    margin: 20px 40px 40px;
    border-radius: 600px;
    height: 60px;
    line-height: 60px;
    background: #33136a;
    text-align: center;
    font-size: 20px;
    span {
      font-variation-settings: "opsz" auto;
      background: linear-gradient(103deg, #4fdeff 2%, #e675ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      font-weight: bold;
    }
  }
}
@media screen and (max-width: 768px) {
  .vocal-dialog {
    .flag {
      width: 120px;
      height: 26px;
      font-size: 12px;
    }
    .name {
      font-size: 32px;
      margin-top: 0px;
    }
    .tip {
      font-size: 12px;
      margin-top: 6px;
      margin-bottom: 3px;
    }
    .vocal-group {
      background: transparent;
      box-shadow: unset;
    }
    .try {
      height: 48px;
      line-height: 48px;
      margin: 4px 20px 24px;
      font-size: 14px;
    }
  }
}
</style>
